import { useMemo } from "react"
import {
  Button,
  Heading,
} from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"
import { ColumnDef } from "@tanstack/react-table"
import { AddIcon } from "@chakra-ui/icons"
import { PaginatedTable } from "../components/PaginatedTable"
import { Saddler } from "../models/Saddler"
import { NavLayout } from "../components/NavLayout"

export const Saddlers = () => {
  const columns = useMemo<ColumnDef<Saddler>[]>(
    () => [
      {
        accessorKey: 'id',
        id: 'id'
      },
      {
        accessorKey: 'first_name',
        header: () => 'First Name',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'last_name',
        header: () => 'Last Name',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'number',
        header: () => 'Number',
        footer: props => props.column.id,
      },
      {
        accessorFn: row => row.active ? 'Yes' : 'No',
        accessorKey: 'active',
        header: () => 'Active',
        footer: props => props.column.id,
      },
    ],
    []
  )

  return (
    <NavLayout
      left={
        <Heading as="h1" size="lg">Saddlers</Heading>
      }
      right={
        <Button
          as={ReactRouterLink}
          to="/saddlers/add"
          boxShadow="dark-lg"
          variant="solid"
          colorScheme="green"
          aria-label="Add Saddler"
          fontSize="20px"
          leftIcon={<AddIcon />}
        >
          Add Saddler
        </Button>
      }
    >
      <PaginatedTable<Saddler> dataKey="saddlers" singular="Saddler" endpoint="/saddlers/index" columns={columns} />
    </NavLayout>
  )
}
